<link *ngIf="config.partner == 8" rel="stylesheet" href="/assets/custom_css/ecuabet.css">
<link *ngIf="config.partner == 0" rel="stylesheet" href="/assets/custom_css/doradobet.css">
<link *ngIf="config.partner == 9" rel="stylesheet" href="/assets/custom_css/winbet.css">
<link *ngIf="config.partner == 13" rel="stylesheet" href="/assets/custom_css/eltribet.css">
<link *ngIf="config.partner == 14" rel="stylesheet" href="/assets/custom_css/loto.css">
<link *ngIf="config.partner == 15" rel="stylesheet" href="/assets/custom_css/hondubet.css">
<link *ngIf="config.partner == 17" rel="stylesheet" href="/assets/custom_css/milbets.css?v=100">
<link *ngIf="config.partner == 18" rel="stylesheet" href="/assets/custom_css/gangabet.css">
<body>
    <!--<div class="preloader"></div> /.preloader -->
    <div class="page-wrapper">

    	<app-header></app-header>

    <!-- routes will be rendered here -->
    	<router-outlet *ngIf="loadView"></router-outlet>

    <!-- footer -->
     	<app-footer></app-footer>

	</div><!-- /.page-wrapper -->
    <a href="#" data-target="html" class="scroll-to-target scroll-to-top"><i class="fa fa-angle-up"></i></a>
    <!-- /.scroll-to-top -->
</body>
